import * as types from '@/store/mutations'

const state = {
    overlayPageOpen: false,
    fullScreenGalleryOpen: false,
    imagesCdnPath: process.env.VUE_APP_CDN_URL + "images",
    imagesCdnV2Path: localStorage.getItem('cdnUrl'),
    isDevEnv:localStorage.getItem('isDevEnv'),
    menuOpen: false,
    customPopupOpen:false
}

const getters = {
    unreadNotifications(){
        let counters = {
            inbox: 0 // TODO: get unread inbox count, what other counts?
        }

        // total
        counters.all = Object.entries(counters).reduce((total,item) => total + (parseInt(item[1]) || 0), 0)

        return counters
    },
    disableScroll(state){
        return state.overlayPageOpen || state.fullScreenGalleryOpen
    },
    isDevEnv(state){
        //console.log(state.isDevEnv)
        return state.isDevEnv
    }
}

const actions = {}

const mutations = {
    [types.CLOSE_MENU](state){
        state.menuOpen = false
        state.customPopupOpen = false
    },
    [types.TOGGLE_MENU](state){
        state.menuOpen = !state.menuOpen
    },
    [types.UPDATE_OVERLAY_ACTIVE](state, value){
        state.overlayPageOpen = value
    },
    [types.UPDATE_FS_GALLERY_STATUS](state, value){
        state.fullScreenGalleryOpen = value
    },
    [types.UPDATE_CUSTOM_POPUP_STATE](state, value){
        state.customPopupOpen = value
    }
}


export default {
    state,
    getters,
    actions,
    mutations
}
